import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

// withCredentials: send/receive HttpOnly auth cookie across origins
export const api = axios.create({
  baseURL: API_BASE,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});

export const WHATSAPP_NUMBER = "917290046341";
export const PHONE_NUMBER = "+91 72900 46341";
export const EMAIL = "travels@acchajeemail.com";
export const GOOGLE_REVIEWS_URL = "https://www.google.com/maps/search/?api=1&query=Acchajee+Travels+Khandsa+Rd+Sector+37+Gurugram";
export const waLink = (msg = "Hi Acchajee Travels, I'd like a free quote.") =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(msg)}`;
